import { useMemo } from 'react';

import { useOmniSignDocumentsContext } from './context';

interface OmniSignDocumentsHook {
  showError: boolean;
  showLoader: boolean;
  showForm: boolean;
}

export default function useOmniSignDocuments(): OmniSignDocumentsHook {
  const { credit, documents, quotePpfB64, isFetching } =
    useOmniSignDocumentsContext();

  const showError = useMemo(() => {
    if (isFetching || !credit || !documents) return false;
    const creditDocuments = credit?.credit_documents;
    if (!creditDocuments) return true;
    if (!quotePpfB64) return true;
    return creditDocuments.length !== documents.length;
  }, [credit, documents, quotePpfB64, isFetching]);

  const showForm = useMemo(
    () => !showError && !isFetching,
    [showError, isFetching],
  );

  return {
    showError,
    showLoader: isFetching,
    showForm,
  };
}
